import { FC, memo, ReactNode } from 'react';

import { dom } from 'app/utils';
import { Menubar, MenubarProps, MenuItem } from './external';
import { IComponent } from './types';

export interface INavbar extends IComponent {
  items?: MenuItem[];
  start?: ReactNode;
  end?: ReactNode;
}

export const Navbar: FC<INavbar> = memo(({ id, className, style, items, start, end }) => {
  const navbar: MenubarProps = { id, style, start, end,
    className: dom.className('i-component', 'i-navbar', 'p-2', 'flex-none', 'border-none', 'border-noround', className),
    model: items,
  };

  return (
    <Menubar { ...navbar } />
  );
});
